<template>
  <VList v-if="model && model.zip && model.city">
    <VListTile class="tile-fix">
      <VListTileContent>
        <VListTileTitle>{{ model.city }}</VListTileTitle>
        <VListTileSubTitle>
          {{ model.zip }} &mdash;
          <template>{{ model.city }}</template>
        </VListTileSubTitle>
      </VListTileContent>
      <VListTileAction>
        <VBtn
          icon
          ripple
          @click="model = null"
        >
          <VIcon color="grey lighten-1">
            close
          </VIcon>
        </VBtn>
      </VListTileAction>
    </VListTile>
  </VList>
  <VAutocomplete
    v-else
    v-model="model"
    :items="items"
    :error-messages="errorMessages"
    :loading="isLoading"
    :no-data-text="noDataText"
    :search-input.sync="search"
    color="white"
    item-text="descr"
    item-value="zip"
    :label="$nt('label')"
    :placeholder="$nt('placeholder')"
    :rules="rules"
    return-object
  />
</template>

<script>
import helperApi from '@/api/HelperApi'
import debounce from 'lodash/debounce'

export default {
  name: 'SelectCity',
  props: {
    errorMessages: {
      type: Array,
      default: () => {}
    },
    rules: {
      type: Array,
      default: () => {}
    },
    // eslint-disable-next-line
    value: {},
    modelForCls: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    entries: [],
    isLoading: false,
    model: null,
    search: null
  }),

  computed: {
    noDataText () {
      if (this.isLoading) {
        return this.$nt('loading')
      }
      return this.$nt('noData')
    },

    items () {
      return this.entries.map(entry => {
        return Object.assign({}, entry, { descr: `${entry.zip} ${entry.name}`, city: entry.name })
      })
    }
  },

  methods: {
    fetchCities: debounce(async function (e) {
      if (!e || e.length < 2) {
        return
      }
      const config = {}
      const isZip = /[0-9]/.test(e)
      if (isZip) {
        config.zip = e
      } else {
        config.name = e
      }
      this.isLoading = true
      this.entries = await helperApi.getCities(config)
      this.isLoading = false
    }, 250)
  },

  watch: {
    search: 'fetchCities',
    model () {
      if (this.model && this.model.name && this.model.zip) return this.$emit('input', this.model)
    },
    modelForCls () {
      this.model = null
    }
  },
  created () {
    this.model = this.value
  }
}
</script>

<style scoped>
  .tile-fix {
    margin: 0 -16px;
  }
</style>
